import { graphql as gql, useStaticQuery } from 'gatsby'
import '@src/data/prismic-fragments/footer'
import { IconType, FooterType } from '@islandsstofa/react'

interface PrismicFooterRaw {
  data: {
    first_row_title: string
    second_row_title: string
    social_media: {
      link: {
        url: string
      }
      platform: IconType
    }[]
    localLinks: {
      link: {
        url: string
        document: {
          uid: string
          data: {
            page_title: {
              text: string
            }
          }
        }
      }
    }[]
    externalLinks: {
      link: {
        url: string
      }
      link_text: string
    }[]
    address?: string
    tel?: string
  }
}

export default (lang: string) => {
  const data: {
    prismicFooter: PrismicFooterRaw
  } = useStaticQuery(gql`
    {
      allPrismicFooter {
        nodes {
          lang
          ...prismicFooterFragment
        }
      }
    }
  `)

  if (!data) {
    return null
  }

  const translatedFooter = data.allPrismicFooter.nodes.filter(
    (node: any) => node.lang.slice(0, 2) === lang
  )[0]

  const cleanedData: FooterType = {
    email: '',
    localLinks: translatedFooter.data.localLinks.map(item => {
      return {
        link: {
          url: item.link.url,
          txt: item.link.document.data.page_title.text
        }
      }
    }),
    externalLinks: translatedFooter.data.externalLinks.map(item => {
      return {
        link: {
          url: item.link.url,
          txt: item.link_text
        }
      }
    }),
    socialMedia: translatedFooter.data.social_media.map(item => {
      return {
        link: {
          url: item.link.url
        },
        platform: item.platform
      }
    }),
    contactData: {
      address: translatedFooter.data.address,
      tel: translatedFooter.data.tel
    },
    localLinksTitle: translatedFooter.data.first_row_title,
    externalLinksTitle: translatedFooter.data.second_row_title
  }

  return cleanedData
}
